module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-datetimepicker"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-date-time-picker', {
    attrs: {
      "datetime": _vm.data.datetime,
      "fallbackDatetime": _vm.now
    },
    on: {
      "change": _vm.handleDateTimePickerChange
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73bc6b0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/DateTimePicker.vue
// module id = 635
// module chunks = 0